import { ReactElement } from "react";
import { colors } from "src/common/constants/colors";
import { CSSProperties } from "styled-components";

export default function chatIcon(props: {
  style: CSSProperties
}): ReactElement {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{ ...props.style }}
    >
      <g style={{ fill: colors.white }}>
        <path
          d="M411,140c-60.1-39.7-140-48.7-206.3-36.8C130.4,31.6,47.2,64.6,31,74.1c0,0,57.1,48.5,47.8,91
		c-67.6,68.9-35.5,145.6,0,181.9c9.3,42.5-47.8,91-47.8,91c16.1,9.5,99,42.3,173.7-28.9c66.2,11.9,146.1,2.9,206.3-36.8
		C504.2,312.7,504.5,199.8,411,140L411,140z M260.8,371.8c-23.2,0.1-46.4-2.9-68.8-8.9l-15.4,14.9c-8.6,8.3-18.2,15.5-28.6,21.4
		c-12.6,6.4-26.3,10.3-40.4,11.5c0.8-1.4,1.5-2.8,2.2-4.1c15.5-28.6,19.6-54.3,12.5-77.1c-25.4-20-40.6-45.6-40.6-73.5
		c0-64.1,80.3-116,179.2-116s179.2,51.9,179.2,116S359.8,371.8,260.8,371.8z M174.8,283.6c-14.8,0.2-26.9-11.6-27.2-26.3
		c-0.5-35.5,53-36.2,53.5-0.9v0.4C201.3,271.4,189.5,283.4,174.8,283.6C174.9,283.6,174.9,283.6,174.8,283.6L174.8,283.6z
		 M232.5,257.2c-0.6-35.5,52.9-36.3,53.5-0.9v0.5C286.3,292,233.1,292.4,232.5,257.2L232.5,257.2z M344.5,283.6
		c-14.8,0.2-26.9-11.6-27.2-26.3c-0.5-35.5,53-36.2,53.5-0.9v0.4c0.2,14.6-11.5,26.6-26.1,26.8C344.6,283.6,344.6,283.6,344.5,283.6
		L344.5,283.6z"
        />
      </g>
    </svg>
  );
}
